import { AbstractControl, ValidationErrors } from "@angular/forms";

export function noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;
  const isWhitespace = (control.value || "").toString().trim().length === 0;
  return !isWhitespace ? null : { whitespace: true };
}